import {
  bootstrapToggleOff,
  bootstrapToggleOn,
} from '@ng-icons/bootstrap-icons';
import {
  heroPencil,
  heroTrash,
  heroEye,
  heroChevronUpDown,
  heroChevronUp,
  heroChevronDown,
  heroUsers,
  heroPlus,
  heroArrowLeft,
  heroPaperAirplane,
  heroBars3,
  heroFunnel,
  heroArrowPath,
  heroBuildingOffice,
  heroArchiveBox,
  heroTrophy,
  heroListBullet,
  heroReceiptPercent,
  heroPlayCircle,
  heroPauseCircle,
  heroClipboardDocumentList,
  heroLink,
  heroUser,
  heroArrowLeftStartOnRectangle,
  heroArrowUturnLeft,
  heroArrowUturnRight,
  heroInformationCircle,
  heroChatBubbleLeftEllipsis,
  heroShieldCheck,
  heroCog8Tooth,
  heroArrowDownTray,
  heroArrowRightStartOnRectangle,
  heroExclamationTriangle,
  heroMapPin,
  heroSignalSlash,
  heroBattery0,
  heroShieldExclamation,
  heroDocumentArrowDown,
  heroPencilSquare,
  heroDocument,
  heroChevronLeft,
  heroCurrencyDollar,
  heroClock,
  heroVideoCamera,
  heroBell,
  heroBellSlash,
  heroBolt,
  heroLockClosed,
  heroQrCode,
  heroLockOpen,
} from '@ng-icons/heroicons/outline';

export const ICONS = {
  heroPencil,
  heroTrash,
  heroEye,
  heroChevronUpDown,
  heroChevronUp,
  heroChevronDown,
  heroUsers,
  heroPlus,
  heroArrowLeft,
  heroPaperAirplane,
  heroBars3,
  heroFunnel,
  heroArrowPath,
  heroBuildingOffice,
  heroArchiveBox,
  heroTrophy,
  heroListBullet,
  heroReceiptPercent,
  heroPlayCircle,
  heroPauseCircle,
  bootstrapToggleOff,
  bootstrapToggleOn,
  heroClipboardDocumentList,
  heroLink,
  heroUser,
  heroArrowLeftStartOnRectangle,
  heroArrowUturnLeft,
  heroArrowUturnRight,
  heroInformationCircle,
  heroChatBubbleLeftEllipsis,
  heroShieldCheck,
  heroCog8Tooth,
  heroArrowDownTray,
  heroArrowRightStartOnRectangle,
  heroExclamationTriangle,
  heroMapPin,
  heroSignalSlash,
  heroBattery0,
  heroShieldExclamation,
  heroDocumentArrowDown,
  heroPencilSquare,
  heroDocument,
  heroChevronLeft,
  heroCurrencyDollar,
  heroClock,
  heroVideoCamera,
  heroBell,
  heroBellSlash,
  heroBolt,
  heroLockClosed,
  heroQrCode,
  heroLockOpen,
};
